import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  fetchTestSessionListRequest,
  fetchTestSessionListSuccess,
  fetchTestSessionListFailure,
  mergeTestSessionsRequest,
  mergeTestSessionsSuccess,
  mergeTestSessionsFailure,
} from "./testSessionListSlice";
import { selectSessionMergeSelection } from "./testSessionListSelectors";
import {
  getTestSuiteSessions,
  mergeTestSuiteSessions,
} from "../../utils/api-communication/RestApiCli";
import { MergeCandidateSession } from "@/types/testSessionTypes";

function requestErrorMessage(error: any, fallback: string): string {
  return error?.response?.data?.message ?? error?.message ?? fallback;
}

function* fetchTestSessionListSaga(action: { type: string; payload: any }) {
  try {
    const query = action.payload;
    const response = yield call(
      () =>
        new Promise((resolve, reject) => {
          getTestSuiteSessions(
            query,
            (res) => resolve(res),
            (err) => reject(err),
            () => reject(new Error("Unauthorized")),
          );
        }),
    );
    const lastPage = response?.data?.lastPage ?? 1;
    const filters = response?.data?.filters ?? {};
    const data = response?.data?.data ?? [];
    yield put(fetchTestSessionListSuccess({ data, lastPage, filters }));
  } catch (error: any) {
    yield put(fetchTestSessionListFailure(error?.message ?? "Failed to fetch test session list"));
  }
}

function* mergeTestSessionsSaga(action: { type: string; payload: { patientId: string } }) {
  try {
    const selection: MergeCandidateSession[] = yield select(selectSessionMergeSelection);
    const sessionIds = selection.map((session) => session.sessionId);
    const mergedSession = yield call(
      () =>
        new Promise((resolve, reject) => {
          mergeTestSuiteSessions(
            { sessionIds, patientId: action.payload.patientId },
            (res) => resolve(res),
            (err) => reject(err),
            () => reject(new Error("Unauthorized")),
          );
        }),
    );
    yield put(mergeTestSessionsSuccess({ sessionId: mergedSession?.sessionId ?? null }));
  } catch (error: any) {
    yield put(
      mergeTestSessionsFailure(requestErrorMessage(error, "Failed to merge test sessions")),
    );
  }
}

export function* watchTestSessionListSaga() {
  yield takeLatest(fetchTestSessionListRequest.type, fetchTestSessionListSaga);
  yield takeLatest(mergeTestSessionsRequest.type, mergeTestSessionsSaga);
}
